import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, Shield } from 'lucide-react';
import { LucideIcon } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

interface RoleCardProps {
  roleName: string;
  description: string;
  variant?: 'free' | 'admin';
}

export function RoleCard({ roleName, description, variant = 'free' }: RoleCardProps) {
  const { t } = useTranslation('pages');
  const Icon: LucideIcon = variant === 'admin' ? Shield : CheckCircle;
  const iconColor = variant === 'admin' ? 'text-primary' : 'text-success';
  const badgeVariant = variant === 'admin' ? 'secondary' : 'secondary';
  const badgeText = variant === 'admin' ? t('billing.badge_admin') : t('billing.badge_free');
  const badgeClasses = variant === 'admin' 
    ? 'bg-primary/10 text-primary border-primary/20'
    : 'bg-success/10 text-success border-success/20';

  return (
    <Card className="h-fit">
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Icon className={`h-5 w-5 ${iconColor}`} />
            <div>
              <h3 className="font-semibold">{roleName}</h3>
              <p className="text-sm text-muted-foreground">{description}</p>
            </div>
          </div>
          <Badge variant={badgeVariant} className={badgeClasses}>
            {badgeText}
          </Badge>
        </div>
      </CardContent>
    </Card>
  );
}